// utils/generateScreenConnectLink.js
export const generateScreenConnectLink = (screenConnectDomain, machineName) => {
  const url = `https://${screenConnectDomain}/Host#Access/All/${machineName}/Join`;
  console.log("CWC url", url);
  return url;
};
